import React from "react";
import { QRCodeSVG } from "qrcode.react";

/**
 * Phase 208 — PIN QR code shown on printable documents (receipts, slips).
 * Encodes the PUBLIC property-lookup page of the Citizen Payment Portal for that PIN:
 *   {origin}/{code}/pay?pin={PIN}
 * Scanning it opens the property (dues, demand lines, pay online) with no login.
 * Mirrors backend `core/pin_qr.py` so PDFs and on-screen prints encode the same URL.
 */
export const PIN_QR_CAPTION = "Scan to view property & pay online";

export const pinLookupPath = (code, pin) => {
  const p = String(pin || "").trim();
  return code && p ? `/${code}/pay?pin=${encodeURIComponent(p)}` : "";
};

export const pinLookupUrl = (code, pin) => {
  const path = pinLookupPath(code, pin);
  return path ? `${window.location.origin}${path}` : "";
};

export const PinQr = ({ code, pin, size = 84, caption = PIN_QR_CAPTION, className = "", testId = "pin-qr" }) => {
  const url = pinLookupUrl(code, pin);
  if (!url) return null;
  return (
    <div className={`flex flex-col items-center gap-1 ${className}`} data-testid={testId} data-url={url}>
      <div className="rounded-md border border-gray-300 bg-white p-1.5">
        <QRCodeSVG value={url} size={size} level="M" includeMargin={false} aria-label={`QR code: ${caption}`} />
      </div>
      {caption && <p className="text-[10px] leading-tight text-gray-600 text-center max-w-[7.5rem]" data-testid={`${testId}-caption`}>{caption}</p>}
    </div>
  );
};
